import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router'

import { getValidationRules } from '../validation/validation'
import LicenseSubscriptionFormComponent from '../components/profile/License/LicenseSubscriptionFormComponent';
import { PERSONAL_SUBSCRIPTIONS, CARDIO_SUBSCRIPTIONS, STRENGTH_SUBSCRIPTIONS, ASSET_SUBSCRIPTIONS, FACILITY_SUBSCRIPTIONS } from '../components/profile/License/LicenseConstants';

const subscriptions = [...PERSONAL_SUBSCRIPTIONS, ...CARDIO_SUBSCRIPTIONS, ...STRENGTH_SUBSCRIPTIONS, ...ASSET_SUBSCRIPTIONS, ...FACILITY_SUBSCRIPTIONS];

export default withRouter(reduxForm({
    form: 'license',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    validate: getValidationRules([
    ].concat(subscriptions.map((subscription) => subscription.name))),
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(LicenseSubscriptionFormComponent));



// WEBPACK FOOTER //
// ./src/containers/LicenseSubscriptionFormContainer.js